















import { Component, Mixins, Ref } from 'vue-property-decorator'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectBase from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import FileDropArea from '@/components/common/atoms/FileDropArea.vue'
import LinkArea from '@/components/branch/organisms/LinkArea.vue'
import HistoryByStudentTable from '@/components/branch/organisms/HistoryByStudentTable.vue'
import HistoryByStudentApis, { HistoryData } from '@/mixins/requests/branch/HistoryByStudentApis.vue'
import PaginationButton from '@/components/common/organisms/PaginationButton.vue'

@Component({
  components: {
    InputSimple,
    SelectBase,
    ButtonBase,
    HistoryByStudentTable,
    FileDropArea,
    LinkArea,
    PaginationButton,
  },
})
export default class HistoryByStudent extends Mixins(HistoryByStudentApis) {
  private studentName = ''

  private historyList: HistoryData[] = []

  // ref: ページネーション
  @Ref() paginationButton!: PaginationButton

  private get bcbtCode() {
    return this.$route.params.bcbtCode
  }

  private async mounted() {
    try {
      await this.loadHistory()
    } catch (e) {
      if (e.response.data.status === 404) {
        // リクエストの生徒IDが存在しない場合は404
        alert('指定の生徒が存在しません')
      } else if (e.response.data.status === 400) {
        // 生徒でないbcbtCodeを指定した場合。URLから直で飛ばない限りここに入らないはず
        alert('不適切なユーザです')
      }
    }
  }

  private onClickComfirmButton(studyContentId: number) {
    // 受験結果画面を別タブで開く
    window.open(`/branch/study-result/${this.bcbtCode}/${studyContentId}`, '_blank')
  }

  private async loadHistory() {
    const historyObject = await this.getHistoryByStudent(this.paginationButton.paginationCurrentPage, this.bcbtCode)
    this.studentName = historyObject.studentName
    this.historyList = historyObject.responses
    this.paginationButton.paging(historyObject.pagination)
  }

  private async onClickPaginationButton() {
    await this.loadHistory()
  }
}
